import React from 'react';

export default function WildRoute() {
  return <div>404</div>;
}
